import { Button, Card, Row } from "antd";

export default function SectionCard({
  children,
  style,
  onPrev,
  onNext,
  nextTitle,
}) {
  return (
    // <Card style={{ padding: 0, borderRadius: 20, maxWidth: 560 }}>
    <Card
      // className="form-section"
      style={{
        padding: 0,
        paddingInline: 30,
        borderRadius: 12,
        maxWidth: 5000,
        ...style,
      }}
    >
      <div
        style={{
          height: 700,
          maxHeight: "65vh",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        {children}
      </div>
      <Row style={{ gap: 10, marginTop: 50 }} align={"end"}>
        <Button style={{ height: 39 }} onClick={onPrev}>
          Go Back
        </Button>
        <Button
          onClick={onNext}
          type="default"
          htmlType="submit"
          // size="large"
          style={{
            backgroundColor: "#BA24D5",
            color: "white",
            borderWidth: 0,
            height: 39,
          }}
        >
          {nextTitle}
        </Button>
      </Row>
    </Card>
  );
}
